module.exports = __webpack_public_path__ + "static/media/3_Minutes_BOD_Formplast_OSA_2016_20160622.ae46d79f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2016/3_Minutes_BOD_Formplast_OSA_2016_20160622.pdf
// module id = 166
// module chunks = 0